import React from 'react';
import {
  ChartsIcon,
  MercIcon,
  SettingsIcon,
  ReportIcon,
} from '../../../../theme/icons';
import {
  Badge,
  Box,
  Button,
  IconButton,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { AlarmIcon } from '../../../../../../theme/icons';
import {
  DefaultMenuButtons,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import { getPolyglot } from '../../../../../../i18n';
import { ViewKey } from '../../MerchandiserContainer';
import { useAppSelector } from '../../../../../../redux/store.model';
import { getAlarmActiveBySelector } from '../../../../../../redux/incident/selectors/getAlarmActiveBySelector';

const useButtons = ({
  onClick,
  merchandiserId,
}: {
  onClick: React.Dispatch<React.SetStateAction<ViewKey>>;
  merchandiserId: string | undefined;
}) => {
  const { data: alarmsActive } = useAppSelector((state) =>
    getAlarmActiveBySelector(state, {
      groupId: merchandiserId,
    })
  );
  return [
    // { icon: <DashBoardIcon />, view: 'dashboard' , onClick: () => navigate('dashboard')},
    {
      icon: <MercIcon />,
      view: 'detail',
      onClick: () => onClick('detail'),
    },
    {
      icon: <SettingsIcon />,
      view: 'settings',
      onClick: () => onClick('settings'),
    },
    {
      icon: <ChartsIcon />,
      view: 'history',
      onClick: () => onClick('history'),
    },
    {
      icon: <ReportIcon />,
      view: 'reports',
      onClick: () => onClick('reports'),
    },
    {
      icon: (
        <Badge badgeContent={alarmsActive?.length} color="error">
          <AlarmIcon />
        </Badge>
      ),
      view: 'alarms',
      onClick: () => onClick('alarms'),
    },
  ];
};

const StyledIconButton = styled(IconButton)<{ active: boolean }>(
  ({ theme, active }) => `
      background-color: ${
        active
          ? theme.palette.secondary.main
          : theme.palette.primary.contrastText
      };
      border-radius: 1rem;
      padding: 1rem;
      margin: 0.5rem;
      width: 4rem;
      &:hover {
        background-color: ${theme.palette.primary.light};
      }
      `
);

interface MerchandiserActionsProps {
  moduleSelected?: string;
  onClick: React.Dispatch<React.SetStateAction<ViewKey>>;
  merchandiserId: string | undefined;
}
function MerchandiserActions(props: MerchandiserActionsProps) {
  const { moduleSelected, onClick, merchandiserId } = props;

  const buttons = useButtons({ onClick, merchandiserId });
  const polyglot = getPolyglot();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={() => ({
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'flex-end',
        fontSize: '1.8em',
        color: (theme) => theme.typography.body1.color,
      })}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={(e) => e.stopPropagation()}
      onMouseLeave={(e) => e.stopPropagation()}
    >
      {isMobile ? (
        <DefaultMenuButtons
          buttons={buttons.map((button) => (
            <MenuItemPrimary
              key={button.view}
              onClick={button.onClick}
              selected={moduleSelected === button.view}
              color={'primary'}
            >
              <Button
                variant="text"
                size={'small'}
                endIcon={button.icon}
              ></Button>
              {polyglot.t(`freshwatch.merchandiser.menu.${button.view}`)}
            </MenuItemPrimary>
          ))}
        ></DefaultMenuButtons>
      ) : (
        buttons.map((button) => (
          <StyledIconButton
            sx={{ boxShadow: 2 }}
            key={button.view}
            active={button.view === moduleSelected}
            onClick={button.onClick}
            color="primary"
          >
            {button.icon}
          </StyledIconButton>
        ))
      )}
    </Box>
  );
}

export default MerchandiserActions;
